/**
 * botanicalscent.eu — theme.js
 * Global UI behaviour: nav, drawers, accordions, product interactions,
 * scroll reveal, wishlist, recently viewed. No framework dependency.
 */
(function () {
  "use strict";

  /* ------------------------------- Mobile nav ------------------------------ */
  function initMobileNav() {
    var nav = document.querySelector("[data-mobile-nav]");
    var openBtn = document.querySelector("[data-mobile-nav-open]");
    if (!nav || !openBtn) return;
    openBtn.addEventListener("click", function () {
      nav.dataset.open = "true";
      document.body.style.overflow = "hidden";
    });
    nav.querySelectorAll("[data-mobile-nav-close]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        nav.dataset.open = "false";
        document.body.style.overflow = "";
      });
    });
  }

  /* ------------------------------- Cart drawer ----------------------------- */
  function initCartDrawer() {
    var drawer = document.querySelector("[data-cart-drawer]");
    var openBtns = document.querySelectorAll("[data-cart-open]");
    if (!drawer) return;
    openBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        drawer.dataset.open = "true";
        document.body.style.overflow = "hidden";
      });
    });
    drawer.querySelectorAll("[data-cart-close]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        drawer.dataset.open = "false";
        document.body.style.overflow = "";
      });
    });
  }
  window.BotanicalscentOpenCart = function () {
    var drawer = document.querySelector("[data-cart-drawer]");
    if (drawer) {
      drawer.dataset.open = "true";
      document.body.style.overflow = "hidden";
    }
  };

  /* ------------------------------ Search modal ----------------------------- */
  function initSearchModal() {
    var modal = document.querySelector("[data-search-modal]");
    var openBtns = document.querySelectorAll("[data-search-open]");
    if (!modal) return;
    openBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        modal.dataset.open = "true";
        var input = modal.querySelector("input[type=search]");
        if (input) window.setTimeout(function () { input.focus(); }, 50);
      });
    });
    modal.querySelectorAll("[data-search-close]").forEach(function (btn) {
      btn.addEventListener("click", function () { modal.dataset.open = "false"; });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") modal.dataset.open = "false";
    });
  }

  /* --------------------------------- FAQ ----------------------------------- */
  function initAccordions() {
    document.querySelectorAll(".faq-item__q").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var panel = btn.nextElementSibling;
        var isOpen = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!isOpen));
        panel.style.maxHeight = isOpen ? "0px" : panel.scrollHeight + "px";
      });
    });
  }

  /* ---------------------------- Collection filters -------------------------- */
  function initFilterToggle() {
    var toggle = document.querySelector("[data-filter-toggle]");
    var panel = document.querySelector("[data-filters]");
    if (!toggle || !panel) return;
    toggle.addEventListener("click", function () {
      panel.dataset.open = String(panel.dataset.open !== "true");
    });
  }

  /* ------------------------------ Product gallery --------------------------- */
  function initGallery() {
    document.querySelectorAll("[data-product-gallery]").forEach(function (gallery) {
      var mainWrap = gallery.querySelector("[data-main-image-wrap]");
      var mainImg = gallery.querySelector("[data-main-image]");
      var thumbs = gallery.querySelectorAll("[data-thumb]");
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          thumbs.forEach(function (t) { t.setAttribute("aria-current", "false"); });
          thumb.setAttribute("aria-current", "true");
          if (mainImg) {
            mainImg.removeAttribute("srcset");
            mainImg.src = thumb.dataset.fullSrc;
          }
          // If this thumbnail corresponds to a specific variant (e.g. a colour),
          // sync the variant picker so the selected option reflects the image.
          if (window.BotanicalscentVariantPicker && thumb.dataset.fullSrc) {
            window.BotanicalscentVariantPicker.selectByImageSrc(thumb.dataset.fullSrc);
          }
        });
      });
      if (mainWrap) {
        mainWrap.addEventListener("click", function () {
          mainWrap.classList.toggle("is-zoomed");
        });
      }
    });
  }

  /* ------------------------------ Variant picker ----------------------------- */
  function initVariantPicker() {
    var form = document.querySelector("[data-product-form]");
    if (!form) return;
    var variantsData = document.querySelector("[data-product-variants]");
    if (!variantsData) return;
    var variants = JSON.parse(variantsData.textContent);
    var idInput = form.querySelector("input[name='id']");
    var priceEl = document.querySelector("[data-product-price]");
    var atcBtn = form.querySelector("button[type=submit]");

    function selectedOptions() {
      var options = [];
      form.querySelectorAll("[data-option-index]").forEach(function (group) {
        var pressed = group.querySelector("[aria-pressed='true']");
        options[parseInt(group.dataset.optionIndex, 10)] = pressed ? pressed.dataset.optionValue : null;
      });
      return options;
    }

    function moneyFormat(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || "en", { style: "currency", currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "EUR" });
    }

    function matchVariant() {
      var options = selectedOptions();
      var match = variants.filter(function (v) {
        return v.options.every(function (opt, i) { return options[i] == null || opt === options[i]; });
      })[0];
      return match;
    }

    function updateAvailability() {
      var options = selectedOptions();
      form.querySelectorAll("[data-option-index]").forEach(function (group, groupIndex) {
        group.querySelectorAll(".variant-option").forEach(function (btn) {
          var testOptions = options.slice();
          testOptions[groupIndex] = btn.dataset.optionValue;
          var possible = variants.some(function (v) {
            return v.options.every(function (opt, i) { return testOptions[i] == null || opt === testOptions[i]; });
          });
          btn.disabled = !possible;
        });
      });
    }

    function syncOptionButtons(variant) {
      form.querySelectorAll("[data-option-index]").forEach(function (group) {
        var index = parseInt(group.dataset.optionIndex, 10);
        var value = variant.options[index];
        group.querySelectorAll(".variant-option").forEach(function (btn) {
          btn.setAttribute("aria-pressed", btn.dataset.optionValue === value ? "true" : "false");
        });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      idInput.value = variant.id;
      if (variant.featured_image && variant.featured_image.src) {
        var gallery = form.closest(".product") ? form.closest(".product").querySelector("[data-product-gallery]") : document.querySelector("[data-product-gallery]");
        var mainImg = gallery ? gallery.querySelector("[data-main-image]") : document.querySelector("[data-main-image]");
        if (mainImg) {
          mainImg.removeAttribute("srcset");
          mainImg.src = variant.featured_image.src;
        }
        if (gallery) {
          gallery.querySelectorAll("[data-thumb]").forEach(function (t) {
            var isMatch = t.dataset.fullSrc && t.dataset.fullSrc.split("?")[0] === variant.featured_image.src.split("?")[0];
            t.setAttribute("aria-current", isMatch ? "true" : "false");
          });
        }
      }
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = "<s>" + moneyFormat(variant.compare_at_price) + "</s> <span class=\"price--sale\">" + moneyFormat(variant.price) + "</span>";
        } else {
          priceEl.innerHTML = "<span>" + moneyFormat(variant.price) + "</span>";
        }
      }
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? "Add to cart" : "Sold out";
      }
      updateAvailability();
    }

    form.querySelectorAll(".variant-option").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.disabled) return;
        var group = btn.closest("[data-option-index]");
        group.querySelectorAll(".variant-option").forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
        btn.setAttribute("aria-pressed", "true");
        applyVariant(matchVariant());
      });
    });

    updateAvailability();

    // Exposed so the thumbnail gallery can drive the variant picker when a
    // shopper clicks a thumbnail that belongs to a specific colour/variant.
    window.BotanicalscentVariantPicker = {
      selectByImageSrc: function (src) {
        var target = src.split("?")[0];
        var variant = variants.filter(function (v) {
          return v.featured_image && v.featured_image.src && v.featured_image.src.split("?")[0] === target;
        })[0];
        if (!variant) return;
        syncOptionButtons(variant);
        applyVariant(variant);
      }
    };
  }

  /* -------------------------------- Quantity --------------------------------- */
  function initQuantity() {
    document.querySelectorAll("[data-quantity-selector]").forEach(function (wrap) {
      var input = wrap.querySelector("input");
      var minus = wrap.querySelector("[data-quantity-minus]");
      var plus = wrap.querySelector("[data-quantity-plus]");
      if (minus) minus.addEventListener("click", function () {
        var v = Math.max(parseInt(input.min || "0", 10), parseInt(input.value, 10) - 1);
        input.value = v;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
      if (plus) plus.addEventListener("click", function () {
        input.value = parseInt(input.value, 10) + 1;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  /* -------------------------------- Sticky ATC -------------------------------- */
  function initStickyAtc() {
    var sticky = document.querySelector("[data-sticky-atc]");
    var trigger = document.querySelector("[data-sticky-atc-trigger]");
    if (!sticky || !trigger || !("IntersectionObserver" in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.dataset.visible = String(!entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(trigger);
  }

  /* ------------------------------- Review carousel ---------------------------- */
  function initReviewNav() {
    var track = document.querySelector("[data-review-track]");
    var prev = document.querySelector("[data-review-prev]");
    var next = document.querySelector("[data-review-next]");
    if (!track) return;
    function amount() {
      var card = track.querySelector(".review-card");
      return card ? card.getBoundingClientRect().width + 24 : 320;
    }
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -amount(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: amount(), behavior: "smooth" }); });
  }

  /* --------------------------- Product recommendations ------------------------ */
  function initProductRecommendations() {
    var section = document.querySelector('[data-section-type="product-recommendations"]');
    if (!section) return;
    var url = section.dataset.url;
    if (!url) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newSection = doc.querySelector('[data-section-type="product-recommendations"]');
        if (newSection && newSection.querySelector(".product-card")) {
          section.innerHTML = newSection.innerHTML;
          section.querySelectorAll("[data-reveal]").forEach(function (el) { el.classList.add("is-visible"); });
        } else {
          section.remove();
        }
      })
      .catch(function () {});
  }

  /* ------------------------------- Recently viewed ---------------------------- */
  function initRecentlyViewed() {
    var STORAGE_KEY = "botanicalscent_recently_viewed";
    var section = document.querySelector("[data-recently-viewed]");
    var current = section ? section.dataset.currentHandle : null;

    if (current) {
      try {
        var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
        stored = stored.filter(function (h) { return h !== current; });
        stored.unshift(current);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(stored.slice(0, 8)));
      } catch (e) {}
    }

    if (!section) return;
    var grid = section.querySelector("[data-recently-viewed-grid]");
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); } catch (e) {}
    handles = handles.filter(function (h) { return h !== current; }).slice(0, 4);
    if (!handles.length) return;

    Promise.all(
      handles.map(function (handle) {
        return fetch("/products/" + handle + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })
    ).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) return;
      grid.innerHTML = products.map(function (p) {
        var image = p.featured_image || (p.images && p.images[0]) || "";
        return (
          '<div class="product-card">' +
          '<a href="' + p.url + '" class="product-card__link">' +
          '<div class="product-card__media"><img src="' + image + '" loading="lazy" alt="' + p.title + '" width="600" height="600" style="width:100%;height:100%;object-fit:cover;"></div>' +
          '<p class="product-card__title">' + p.title + '</p>' +
          '<p class="product-card__price">' + (p.price / 100).toLocaleString(document.documentElement.lang || "en", { style: "currency", currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "EUR" }) + '</p>' +
          '</a></div>'
        );
      }).join("");
      section.hidden = false;
    });
  }

  /* ----------------------------------- Wishlist -------------------------------- */
  function initWishlist() {
    var STORAGE_KEY = "botanicalscent_wishlist";
    function getList() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); } catch (e) { return []; }
    }
    function setList(list) { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
    var list = getList();
    document.querySelectorAll("[data-wishlist-toggle]").forEach(function (btn) {
      var id = btn.dataset.productId;
      btn.setAttribute("aria-pressed", String(list.indexOf(id) > -1));
      btn.addEventListener("click", function () {
        var current = getList();
        var idx = current.indexOf(id);
        if (idx > -1) { current.splice(idx, 1); btn.setAttribute("aria-pressed", "false"); }
        else { current.push(id); btn.setAttribute("aria-pressed", "true"); }
        setList(current);
      });
    });
  }

  /* -------------------------------- Quick add ---------------------------------- */
  function initQuickAdd() {
    document.querySelectorAll("[data-quick-add]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var variantId = btn.dataset.variantId;
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = "Adding...";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function () { return window.BotanicalscentRefreshCart ? window.BotanicalscentRefreshCart() : null; })
          .then(function () {
            btn.textContent = "Added";
            if (window.BotanicalscentOpenCart) window.BotanicalscentOpenCart();
            window.setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
          })
          .catch(function () { btn.textContent = original; btn.disabled = false; });
      });
    });
  }

  /* -------------------------------- Free shipping bar --------------------------- */
  window.BotanicalscentUpdateFreeShippingBar = function (cart) {
    var bar = document.querySelector("[data-free-shipping-bar]");
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10);
    if (!threshold) return;
    var text = bar.querySelector("[data-free-shipping-text]");
    var fill = bar.querySelector("[data-free-shipping-fill]");
    var remaining = threshold - cart.total_price;
    var percent = Math.min(100, (cart.total_price / threshold) * 100);
    if (fill) fill.style.width = percent + "%";
    if (text) {
      text.innerHTML = remaining > 0
        ? "Add <strong>" + (remaining / 100).toLocaleString(document.documentElement.lang || "en", { style: "currency", currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "EUR" }) + "</strong> more for free shipping"
        : "You've unlocked free shipping!";
    }
  };

  /* ---------------------------------- Reveal ------------------------------------- */
  function initReveal() {
    if (document.documentElement.dataset.animations === "off") return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    document.documentElement.classList.add("reveal-js");
    var items = document.querySelectorAll("[data-reveal]");
    if (!items.length || !("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -40px 0px" });
    items.forEach(function (el) { observer.observe(el); });
  }

  /* ------------------------------- Announcement bar -------------------------------- */
  function initAnnouncementBar() {
    var track = document.querySelector("[data-announcement-track]");
    var bar = document.querySelector("[data-announcement-bar]");
    if (!track) return;
    var items = track.querySelectorAll(".announcement-bar__item");
    if (items.length < 2) return;
    var seconds = parseInt((bar && bar.dataset.rotateSeconds) || "5", 10);
    var index = 0;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    window.setInterval(function () {
      items[index].hidden = true;
      index = (index + 1) % items.length;
      items[index].hidden = false;
    }, Math.max(3, seconds) * 1000);
  }

  function initAll() {
    initMobileNav();
    initCartDrawer();
    initSearchModal();
    initAccordions();
    initFilterToggle();
    initGallery();
    initVariantPicker();
    initQuantity();
    initStickyAtc();
    initReviewNav();
    initProductRecommendations();
    initRecentlyViewed();
    initWishlist();
    initQuickAdd();
    initAnnouncementBar();
    initReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
